import React, { useEffect, useState, useMemo } from "react";
import { filterBy } from "@progress/kendo-data-query";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useDispatch, useSelector } from "react-redux";
import { DisplayMsg } from "../../../services/toastService";
import ClientProgress from "./ClientProgress";
import { setCurrentClientId } from "../../../store/reducers/SharedLayoutDataSlice";
import { setUrl } from "../../../handlers";

const ClientSection = React.memo((props) => {
  const dropDownData = useSelector((state) => state.DropdownList);
  const dispatch = useDispatch();
  const [ClientData, setClientData] = useState();
  const [client, setClient] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [ImpInfo, setImpInfo] = useState({
    salesPerson: "",
    manager: "",
    custAccNum: null,
    salesDisable: false,
    reRender: false,
    defaultCustomer: "",
  });

  const impFilter = {
    salesPerson: "",
    impManager: "",
    customerId: "",
  };

  const [CustomerData, setCustomerData] = useState(
    dropDownData.CustomersList.slice()
  );

  const [SalesPersonOptions, setSalesPersonOptions] = useState([
    { label: "-Select-", value: "" },
  ]);
  const [ImpManagerOptions, setImpManagerOptions] = useState([]);
  const [check, setCheck] = useState(false);

  const reloadProgress = useMemo(
    () => ({
      reload: ImpInfo.reRender,
      customerId: ImpInfo.defaultCustomer,
      selectedCustomer:
        selectedCustomer == null
          ? ClientData != null
            ? ClientData[0]
            : null
          : selectedCustomer,
    }),
    [ImpInfo.reRender]
  );
  useEffect(() => {
    if (SalesPersonOptions.length === 1) {
      LoadDashbaordDropdown();
    }
    if (check === false) {
      LoadClientData();
    }
    RolesDataShow();
  }, []);

  const LoadDashbaordDropdown = () => {
    try {
      document.getElementById("loader").style.display = "block";
      fetch(setUrl("HOME", "LOADDROPDOWN", true))
        .then((response) => response.json())
        .then((json) => {
          const ManagerItems = JSON.parse(json.ImplementaionManager);
          const SalesItems = JSON.parse(json.SalesManager);

          if (ManagerItems != null) {
            const emptyData = {
              label: " - ALL - ",
              value: "",
            };
            setImpManagerOptions((prevImpManager) => [
              ...prevImpManager,
              emptyData,
            ]);

            ManagerItems.forEach((item, key) => {
              const managerOption = {
                label: item.IMPLEMENTATION_MANAGER,
                value: item.IMPLEMENTATION_MANAGER,
              };

              setImpManagerOptions((prevImpManager) => [
                ...prevImpManager,
                managerOption,
              ]);
            });
          }

          if (SalesItems != null) {
            const updatedSalesPerson = SalesItems.filter(
              (item) => item.SALES_PERSON !== "- SELECT -"
            );

            updatedSalesPerson.forEach((item, key) => {
              const salesOption = {
                label: item.SALES_PERSON,
                value:
                  item.SALES_PERSON === "- SELECT -" ? "" : item.SALES_PERSON,
              };

              setSalesPersonOptions((prevInfo) => [...prevInfo, salesOption]);
            });

            const userType = sessionStorage.type.toUpperCase();

            if (userType === "SP") {
              const currentSalesPerson =
                `${sessionStorage.firstName} ${sessionStorage.lastName}`;
              setImpInfo((prevDetail) => ({
                ...prevDetail,
                salesPerson: currentSalesPerson,
              }));
            }
          } else {
            const emptyData = {
              label: " - SELECT - ",
              value: "",
            };
            setSalesPersonOptions((prevInfo) => [...prevInfo, emptyData]);
          }

          document.getElementById("loader").style.display = "none";
        })
        .catch((error) => {
          DisplayMsg("2", error.Message);
        });
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const RolesDataShow = () => {
    const userType = sessionStorage.type.toUpperCase();
    const show_Support = sessionStorage.show_support.toUpperCase();
    const show_Implementation =
      sessionStorage.show_implementation.toUpperCase();
    if (show_Support === "Y" && show_Implementation === "Y") {
      setImpInfo((prevDetail) => ({
        ...prevDetail,
        salesDisable: userType !== "SA",
      }));
    }
  };

  const LoadClientData = () => {
    try {
      const userType = sessionStorage.type.toUpperCase();

      if (userType === "SP") {
        const name =
          `${sessionStorage.firstName} ${sessionStorage.lastName}`;
        impFilter.salesPerson = name;
        setImpInfo((prevDetail) => ({
          ...prevDetail,
          salesDisable: true,
          salesPerson: name,
        }));
      } else if (userType === "SA") {
        setImpInfo((prevDetail) => ({
          ...prevDetail,
          salesDisable: false,
        }));
      }
      document.getElementById("loader").style.display = "block";
      const formData = new FormData();

      formData.append("ddlImplementationMgr", impFilter.impManager);
      formData.append("ddlSalesMgr", impFilter.salesPerson);
      formData.append("ddlCustAccNums", impFilter.customerId);

      formData.append("userType", sessionStorage.type);
      formData.append("CP", sessionStorage.CP);
      formData.append("Reseller", sessionStorage.Reseller);

      const filter =
        `&userType=${sessionStorage.type
        }&CP=${sessionStorage.CP
        }&APPUSER=${sessionStorage.USER
        }&Reseller=${sessionStorage.Reseller}`;
      fetch(setUrl("HOME", "LOADCLIENTS") + filter, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.ClientData !== "") {
            const clientInfo = JSON.parse(result.ClientData);

            setImpInfo((prevDetail) => ({
              ...prevDetail,
              defaultCustomer: clientInfo[0].SEQ_NUM,
            }));
            const ClientsInfo = [...JSON.parse(result.ClientData)];
            for (const [index] of ClientsInfo.entries()) {
              if (index === 0) {
                ClientsInfo[index] = { ...ClientsInfo[index], isCheck: true };
              } else {
                ClientsInfo[index] = { ...ClientsInfo[index], isCheck: false };
              }
            }
            setClientData(ClientsInfo);
            setClient(true);

            setImpInfo((prevDetail) => ({
              ...prevDetail,
              reRender: !ImpInfo.reRender,
            }));
          } else {
            dispatch(setCurrentClientId(""));
            setClient(false);
            setClientData("");
          }
          document.getElementById("loader").style.display = "none";
          setCheck(false);
        })
        .catch((error) => {
          DisplayMsg("2", error.Message);
        });
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const Clientlist = () => {
    const myArray = [];
    ClientData.forEach((item, index) => {
      const speciality = item.SPECIALITY
        ? item.PRACTICE_CITY
          ? `${item.SPECIALITY}/ ${item.PRACTICE_CITY}`
          : item.SPECIALITY
        : "";

      if (item.PRACTICE_NAME || speciality) {
        let ClientServices = "(";
        if (item.RCMTYPE === "Y") {
          ClientServices += "RCM";
        } else {
          ClientServices += item.BILLING_FLAG === "Y" ? "EHR/EHRPM" : "EHR";
          ClientServices += item.CHTYPE === "Y" ? "/Clearing House" : "";
        }
        ClientServices += ")  ";
        if (item.IS_TELE_CLINIC === "Y" || item.KIOSK_FLAG === "Y") {
          ClientServices += "(";
          ClientServices += item.IS_TELE_CLINIC === "Y" ? "Tele visit" : "";
          ClientServices +=
            item.IS_TELE_CLINIC === "Y" && item.KIOSK_FLAG === "Y" ? ", " : "";
          ClientServices += item.KIOSK_FLAG === "Y" ? "Kiosk" : "";
          ClientServices += ")";
        }
        if (item.ALERT === "R") {
          myArray.push(
            <li
              className={`currentItem cursor-pointer p-2 ${item.isCheck ? "bg-gray-300 rounded-3" : ""
                }`}
              key={item.SEQ_NUM || index}
              id={`client_${item.AUTH_ENTITY_SEQ_NUM}`}
              ClientServices={ClientServices}
              onClick={() => ShowProgress(item, index)}
            >
              <span
                style={{
                  display: 'inline-block',
                  maxWidth: '100px',
                  whiteSpace: 'normal',
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                  textOverflow: 'ellipsis',
                  verticalAlign: 'middle'
                }}

              >
                <img
                  src="images/sp.gif"
                  alt=""
                  className="statusBox currentItemsImageRed"
                />
                {item.PRACTICE_NAME}
              </span>

              <span>
                {item.SPECIALITY}/{item.PRACTICE_CITY}
              </span>
              <span>{item.PRACTICE_SETUP}</span>
              <span>{item.CHANNEL_PARTNER}</span>
            </li>
          );
        } else if (item.ALERT === "G") {
          myArray.push(
            <li
              className={`currentItem cursor-pointer p-2 ${item.isCheck ? "bg-gray-300 rounded-3" : ""
                }`}
              key={item.label}
              ClientServices={ClientServices}
              onClick={() => ShowProgress(item, index)}
            >
              <span
                style={{
                  display: 'inline-block',
                  maxWidth: '100px',
                  whiteSpace: 'normal',
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                  textOverflow: 'ellipsis',
                  verticalAlign: 'middle'
                }}
              >
                <img
                  src="images/sp.gif"
                  alt=""
                  className="statusBox currentItemsImageGreen"
                />
                {item.PRACTICE_NAME}
              </span>

              <span>
                {item.SPECIALITY}/{item.PRACTICE_CITY}
              </span>
              <span>{item.PRACTICE_SETUP}</span>
              <span>{item.CHANNEL_PARTNER}</span>
            </li>
          );
        } else if (item.ALERT === "Y") {
          myArray.push(
            <li
              className={`currentItem cursor-pointer p-2 ${item.isCheck ? "bg-gray-300 rounded-3" : ""
                }`}
              key={item.SEQ_NUM || index}
              id={`client_${item.AUTH_ENTITY_SEQ_NUM}`}
              ClientServices={ClientServices}
              onClick={() => ShowProgress(item, index)}
            >
              <span
                style={{
                  display: 'inline-block',
                  maxWidth: '100px',
                  whiteSpace: 'normal',
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                  textOverflow: 'ellipsis',
                  verticalAlign: 'middle'
                }}
              >
                <img
                  src="images/sp.gif"
                  alt=""
                  className="statusBox currentItemsImageYellow"
                />
                {item.PRACTICE_NAME}
              </span>

              <span>
                {item.SPECIALITY}/{item.PRACTICE_CITY}
              </span>
              <span>{item.PRACTICE_SETUP}</span>
              <span>{item.CHANNEL_PARTNER}</span>
            </li>
          );
        } else {
          myArray.push(
            <li
              className={`currentItem cursor-pointer p-2 ${item.isCheck ? "bg-gray-300 rounded-3" : ""
                }`}
              key={item.SEQ_NUM || index}
              id={`client_${item.AUTH_ENTITY_SEQ_NUM}`}
              ClientServices={ClientServices}
              onClick={() => ShowProgress(item, index)}
            >
              <span
                style={{
                  display: 'inline-block',
                  maxWidth: '100px',
                  whiteSpace: 'normal',
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                  textOverflow: 'ellipsis',
                  verticalAlign: 'middle'
                }}
              >{item.PRACTICE_NAME}</span>

              <span>{item.SPECIALITY}</span>
              <span>{item.PRACTICE_SETUP}</span>
              <span>{item.CHANNEL_PARTNER}</span>
            </li>
          );
        }
      }
    });
    return myArray;
  };

  const ShowProgress = (item, curIndex) => {
    const ClientArray = [...ClientData];
    for (const [index, client] of ClientArray.entries()) {
      if (client.SEQ_NUM === item.SEQ_NUM && index === curIndex) {
        setImpInfo((prevDetail) => ({
          ...prevDetail,
          defaultCustomer: item.SEQ_NUM,
          reRender: !ImpInfo.reRender,
        }));
        setClient(true);
        setSelectedCustomer(ClientArray[index]);
        ClientArray[index] = { ...ClientArray[index], isCheck: true };
      } else {
        ClientArray[index] = { ...ClientArray[index], isCheck: false };
      }
    }

    setClientData(ClientArray);
  };

  const FilterImplementationInfo = (e) => {
    const curName = e.target.name;
    const curVal = e.target.value;
    switch (curName) {
      case "person":
        impFilter.salesPerson = curVal;
        setImpInfo((impData) => ({
          ...impData,
          salesPerson: curVal,
        }));
        break;
      case "manager":
        impFilter.impManager = curVal;
        setImpInfo((impData) => ({
          ...impData,
          manager: curVal,
        }));
        break;
      default:
        break;
    }
    LoadClientData();
  };

  const FilterCustomer = (filter) => {
    const data = dropDownData.CustomersList.slice();
    return filterBy(data, filter);
  };

  const AlterCustomer = (event) => {
    let updatedCustomers = [];
    const newCustomer =
      event.filter.value.length > 2
        ? FilterCustomer(event.filter)
        : dropDownData.CustomersList.slice();
    updatedCustomers = [...new Set(newCustomer)];
    setCustomerData(updatedCustomers);
  };

  const AlterComboBoxData = (event) => {
    const curVal = event.target.value;
    const fieldName = "custAccNum";

    impFilter.customerId = event.value != null ? curVal.value : "";
    setImpInfo((ticketData) => ({
      ...ticketData,
      [fieldName]: curVal,
    }));

    LoadClientData();
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-md-3 col-sm-3">
          <div className="field-container">
            <label className="field-placeholde font-medium">Sales Person</label>
            <select
              className="field-input"
              name="person"
              value={ImpInfo.salesPerson}
              onChange={(e) => FilterImplementationInfo(e)}
              disabled={ImpInfo.salesDisable}
            >
              {SalesPersonOptions.map((option) => (
                <option value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-md-3 col-sm-3">
          <div className="field-container">
            <label className="field-placeholder font-medium">
              Implementation Manager
            </label>
            <select
              className="field-input"
              name="manager"
              value={ImpInfo.manager}
              onChange={(e) => FilterImplementationInfo(e)}
            >
              {ImpManagerOptions.map((option) => (
                <option value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-md-3 col-sm-3">
          <div className="textBoxValidate field-container">
            <label className="field-placeholder font-medium">Customer Id</label>
            <ComboBox
              className="field-input"
              data={CustomerData}
              value={ImpInfo.custAccNum === "" ? null : ImpInfo.custAccNum}
              name="custAccNum"
              textField="text"
              filterable
              onFilterChange={AlterCustomer}
              onChange={AlterComboBoxData}
            />
          </div>
        </div>
      </div>
      <div className="pgSize">
        <div id="mainController">
          <div className="home_Container">
            <div className="InputTable">
              <div className="row">
                <div className="col-4 col-dashboard4 position-relative">
                  <ul className="listHeader">
                    <li>
                      <span>CLIENT NAMES</span>
                      <span>SPECIALITY</span>
                      <span>PR SETUP</span>
                      <span>CP</span>
                    </li>
                  </ul>
                  <div id="clients_Container">
                    {ClientData && ClientData.length > 0 ? (
                      <>
                        <ul className="listContainer client-list">
                          {Clientlist(ClientData)}
                        </ul>
                        <ul className="listFooter">
                          <li>
                            <div>
                              Total Count: &nbsp;
                              <span id="txtClientsCount">
                                {ClientData.length}
                              </span>
                            </div>
                          </li>
                        </ul>
                      </>
                    ) : (
                      <div className="flex flex-center justify-content-center noDataFound noDataFound progress-setup mainSetup">
                        No Data Found
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="col-8 col-dashboard8 position-relative"
                  id="divProgressData"
                >
                  <div id="clients_Progress">
                    {/* customerId={ImpInfo.defaultCustomer} selectedCustomer={selectedCustomer == null ? ClientData[0] : selectedCustomer} */}
                    {client === true ? (
                      <ClientProgress data={reloadProgress} />
                    ) : (
                      <div>
                        <p className="flex justify-content-between listHeader listProgress p-0 h-4rem" />
                        <div className="flex flex-center justify-content-center noDataFound noDataFound progress-setup mainSetup">
                          No Data Found
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default ClientSection;
